import { Injectable } from '@angular/core';
import { Task, Transition } from './types';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class WorkflowStateManager {
    task: Task;
    transitionsEnabled = true;

    // Notifications from "state processor" to "biz modules"
    transitionClick = new Subject<Transition>();
    returnClick = new Subject<any>();

    // Notifications from "biz modules" to "state processor"
    enableTransition = new Subject<{ transitionId: number, enabled: boolean }>();
    done = new Subject<any>();

    reset() {
        this.task = null;
        this.transitionClick = new Subject<any>();
        this.returnClick = new Subject<any>();
        this.enableTransition = new Subject<any>();
        this.done = new Subject<any>();
    }
}
